<template>
  <v-container>
    <v-data-iterator
      :items="items"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :sort-by="sortBy.toLowerCase()"
      :sort-desc="sortDesc"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:header>
        <v-toolbar class="mb-1">
          <v-text-field
            v-model="search"
            clearable
            flat
            solo-inverted
            hide-details
            prepend-inner-icon="mdi-search"
            label="Search"
            dense
          ></v-text-field>
        </v-toolbar>
        <v-alert type="success" v-if="statusResult == 1">{{
          statusResultMsg
        }}</v-alert>
        <v-alert type="error" v-if="statusResult == 0">{{
          statusResultMsg
        }}</v-alert>
      </template>

      <template v-slot:default="props">
        <v-row>
          <v-radio-group v-model="radioGroup" dense>
            <v-col v-for="(item, i) in props.items" :key="i" cols="12">
              <v-card>
                <div>
                  <v-card-title class="subheading">
                    <v-radio
                      :key="i"
                      :value="item.MID"
                      @click="radioClicked(item.MID)"
                    ></v-radio>
                    <v-avatar size="24" right
                      ><img :src="item.FlagUrl"
                    /></v-avatar>
                    <v-spacer></v-spacer>
                    {{ item.SearchName }}
                    <v-spacer></v-spacer>
                    <v-btn
                      rounded
                      x-small
                      :depressed="showEdit"
                      @click="toggleEdit"
                      v-if="item.IsPilot || item.IsAdmin"
                      ><v-icon small>mdi-pencil</v-icon></v-btn
                    >
                    <v-chip x-small color="orange" v-if="item.IsCrew"
                      >Crew</v-chip
                    >
                    <v-chip x-small>{{ item.Class }}</v-chip>
                    <v-chip x-small :color="item.PersonalColor">{{
                      item.PersonalStatus
                    }}</v-chip>
                    <v-chip x-small :color="item.Color">{{
                      item.Status
                    }}</v-chip>
                  </v-card-title>
                  <div v-if="item.IsPilot || item.IsAdmin">
                    <v-row>
                      <v-col cols="1"></v-col>
                      <v-col
                        v-if="(item.IsPilot || item.IsAdmin) && showEdit"
                        align="center"
                      >
                        <v-checkbox
                          v-model="item.IsCrew"
                          :input-value="item.IsCrew"
                          label="Crew member"
                        ></v-checkbox>
                        <label>Class</label>
                        <v-select
                          v-model="item.Class"
                          :items="classes"
                          :item-value="item.Class"
                          :label="item.Class"
                          dense
                          outlined
                        ></v-select>
                        <v-label>P-Status</v-label>
                        <v-select
                          v-model="item.PersonalStatus"
                          :items="personalstatus"
                          :item-value="item.PersonalStatus"
                          :label="item.PersonalStatus"
                          dense
                          outlined
                        ></v-select>
                        <v-label v-if="item.IsAdmin">A-Status</v-label>
                        <v-select
                          v-model="item.Status"
                          :items="status"
                          :item-value="item.Status"
                          :label="item.Status"
                          dense
                          outlined
                          v-if="item.IsAdmin"
                        ></v-select>
                        <v-btn
                          color="primary"
                          rounded
                          small
                          @click="submit(item)"
                          >SAVE</v-btn
                        >
                      </v-col>
                      <v-col v-if="item.IsAdmin && !showEdit">
                        <v-label>A-Status</v-label>
                        <v-select
                          v-model="item.Status"
                          :items="status"
                          :item-value="item.Status"
                          :label="item.Status"
                          dense
                          outlined
                          @change="submit(item)"
                        ></v-select>
                      </v-col>
                      <v-col cols="1"></v-col>
                    </v-row>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-radio-group>
        </v-row>
      </template>
      <template v-slot:footer>
        <v-card outlined href>
          <v-container fluid>
            <a :href="selectedMID"> {{ selectedMID }} </a>
          </v-container>
        </v-card>
      </template>
    </v-data-iterator>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "HappPilotsCard",
  props: {
    items: {
      type: Array,
    },
    regId: Number,
    ac: String,
    loading: Boolean,
  },
  data() {
    return {
      // itemsPerPageArray: [1000, 2000, 3000, 4000],
      search: "",
      filter: {},
      sortDesc: false,
      page: 1,
      itemsPerPage: 1000,
      sortBy: "event",
      radioGroup: 1,
      selectedMID: "",
      // keys: ["Event", "EventDescription", "Status"],
      e1: 1,
      classes: [
        { text: "Open", value: 1 },
        { text: "Sport", value: 2 },
        { text: "Fun", value: 3 },
        { text: "Other", value: 4 },
        { text: "Crew", value: 5 },
      ],
      personalstatus: [
        { text: "Registered", value: 1 },
        { text: "Absent", value: 2 },
        { text: "Cancelled", value: 3 },
      ],
      status: [
        { text: "In Progress", value: 1 },
        { text: "Waiting List", value: 2 },
        { text: "Waiting Payment", value: 3 },
        { text: "Confirmed", value: 4 },
      ],
      showEdit: false,
      statusResult: null,
      statusResultMsg: null,
    };
  },
  created() {
    this.statusResult = -1;
    this.statusResultMsg = "NA";
  },
  methods: {
    toggleEdit() {
      this.showEdit = !this.showEdit;
    },
    radioClicked(mid) {
      // console.log('MID:',mid)
      this.selectedMID = "tel:" + mid;
    },
    submit(item) {
      this.statusResult = -1;
      var happId = item.HappId;
      // console.log("happId",happId);
      var regId = this.regId;
      // console.log("regId",regId);
      var ac = this.ac;
      // console.log("ac",ac);
      var isAdmin = item.IsAdmin;
      // console.log("isAdmin",isAdmin);
      var pilotRegId = item.RegId;
      // console.log("pilotRegId",pilotRegId);
      var classId = this.classes.find((obj) => obj.text == item.Class).value;
      // console.log("classId",classId);
      var personalStatusId = this.personalstatus.find(
        (obj) => obj.text == item.PersonalStatus
      ).value;
      // console.log("personalStatusID",personalStatusId);
      var statusId = this.status.find((obj) => obj.text == item.Status).value;
      // console.log("statusId",statusId);
      var isCrew = item.IsCrew;
      // console.log("isCrew",isCrew);
      var toSubmit = {
        happId,
        regId,
        ac,
        isAdmin,
        pilotRegId,
        classId,
        personalStatusId,
        statusId,
        isCrew,
      };

      //console.log("toSubmit",toSubmit);
      // console.log("item",item);
      // const baseUrl = 'http://localhost:3000/dbapi/' //https://pgbox.azurewebsites.net:3000/
      const baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
      this.post(baseUrl + "setHappPilotStatus", toSubmit);
    },
    post(uri, toSubmit) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          this.statusResult = response.data[0].Result;
          this.statusResultMsg = response.data[0].ResultMsg;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
  },
};
</script>